import React from 'react';
import { Documents } from '../../../../../components';
import { buildAutomationChildTestId, resolveAutomationTestId } from '../../../../../components/InputField/testId';

const ProofOfDocuments = ({
    supportedFiles = ["image", "pdf"],
    single = false,
    enableOnline,
    seq,
    isAskForInfo,
    remark,
    recordId,
    asLabel,
    label,
    field,
    showCategory,
    ubo_id,
    type,
    formId,
    required = true,
    error = "",
    validateByAi = false,
    onValidationStatusChange = () => { },
    dataTestId,
    dataRecordId,
}) => {
    const resolvedTestId = resolveAutomationTestId(dataTestId);

    return (
        <div className='row document-proof w-100 flex-1' data-testid={resolvedTestId} data-record-id={dataRecordId}>
            <InputLabel label={label} required={required} testId={buildAutomationChildTestId(resolvedTestId, "label")} />
            <div className='mt-2 ps-3 mb-0 pb-0' data-testid={buildAutomationChildTestId(resolvedTestId, "remark")}>
                {isAskForInfo ? remark : ""}
            </div>
            <Documents
                dataTestId={buildAutomationChildTestId(resolvedTestId, "documents")}
                asLabel={asLabel}
                inline
                seq={seq}
                field={field}
                record_id={recordId}
                showCategory={showCategory}
                ubo_id={ubo_id}
                type={type}
                formId={formId}
                hideUpload
                isAskForInfo={isAskForInfo}
                enableOnline={enableOnline}
                supportedFiles={supportedFiles}
                single={single}
                error={error}
                validateByAi={validateByAi}
                onValidationStatusChange={onValidationStatusChange}
            />
        </div>
    );
};

export const InputLabel = ({ label, required, labelStyle, testId }) => (
    <div style={{ minWidth: "120px", fontSize: 16, margin: "5px 0px 0px 5px", fontWeight: "500", ...labelStyle }} data-testid={testId}>
        {label}
        {required && <font color="red">*</font>}
    </div>
);

export default ProofOfDocuments;
